import classNames from "classnames";
import { FC, useCallback } from "react";

import Modal from "components/Modal";

import { RootStore } from "store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { removeReportRequest } from "store/slices/reportsSlice";

import ModalRemoveReportContent from "./Content";

import styles from "./styles.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  id?: number;
};

const WidgetModalRemoveReport: FC<PropTypes> = ({ isVisible, className, id }) => {
  const dispatch = useAppDispatch();
  const isRemoving = useAppSelector((state: RootStore) => state.reports.isRemoving);

  const handleDelete = useCallback(() => {
    if (id == null) return;
    dispatch(removeReportRequest(id));
  }, [dispatch, id]);

  return (
    <Modal
      title="Delete report"
      isClose
      isCloseBg
      isVisible={isVisible}
      className={classNames(styles.modal, className)}
    >
      <ModalRemoveReportContent onConfirm={handleDelete} isLoading={isRemoving} />
    </Modal>
  );
};

export default WidgetModalRemoveReport;
